import { ComponentsOverrides, Theme } from "@mui/material";

const MuiTabs: ComponentsOverrides<Theme>["MuiTabs"] = {
  root: {
    borderBottom: "1px solid #E4E7EF",
  },
};

export default MuiTabs;
